import { explicitMaybe } from '@execonline-inc/decoders';
import { Decoder, array, boolean, dateISO, field, number, string, succeed } from 'jsonous';
import { fromEmpty } from 'maybeasy';
import { resourceDecoder } from '../../Resource/Decoders';
import { User, UserResource } from '../Types';

/**
 * There is an issue with the User API and decoder in that name will
 * always be a Just value, even when the name is an empty string
 * (https://execonline.leankit.com/card/773532815). That's why there's the
 * notWhiteSpaceOnlyDecoder in use here. Work on that defect should include
 * removing the use of this decoder.
 */
const notWhitespaceOnlyDecoder = string.map((s) => s.trim()).map(fromEmpty);

const currentUserDecoder: Decoder<User> = succeed({})
  .assign('id', field('id', number))
  .assign('platformUserId', field('platform_user_id', explicitMaybe(number)))
  .assign('name', field('name', notWhitespaceOnlyDecoder))
  .assign('shortName', field('short_name', string))
  .assign('email', field('email', string))
  .assign('initials', field('initials', string))
  .assign('organizationId', field('organization_id', number))
  .assign('organizationAccountUID', field('organization_account_uid', string))
  .assign('organizationName', field('organization_name', string))
  .assign('contactUID', field('contact_uid', explicitMaybe(string)))
  .assign('exoOrg', field('exo_org', boolean))
  .assign('organizationPlatformOrgUID', field('organization_platform_org_uid', string))
  .assign('productLicenseIds', field('product_license_ids', array(number)))
  .assign('productLicenseTypeIds', field('product_license_type_ids', array(number)))
  .assign('epPrivilegeIds', field('ep_privilege_ids', array(number)))
  .assign('inactivityTimeoutMinutes', field('inactivity_timeout_minutes', number))
  .assign('createdAt', field('created_at', dateISO))
  .assign('exoChatbotAccessible', field('exo_chatbot_accessible', boolean))
  .assign('loginType', field('login_type', string))
  .assign('enrollmentDetails', field('enrollment_details', array(string)))
  .assign('userProductLicenseDetails', field('user_product_license_details', array(string)));

export const currentUserResourceDecoder: Decoder<UserResource> =
  resourceDecoder(currentUserDecoder);
